module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/generateAI.2faf6012.svg";